const MetricIDs = {
  TopReasonsforClaimsNonPayment: '100',
  ClaimAppealsOverturnRate: '101',
  TopClaimAppealsOverturnReasons: '102',
  ClaimsPaid: '103',
  ClaimsYield: '104',
  ClaimsAppealsSubmitted: '105',
  ClaimAppealsOverturned: '106',
  ClaimsNotPaid: '107',
  ClaimsNonPaymentRate: '108',
  TotalClaimsSubmitted: '109',
  ActualAllowed: '110',
  ExpectedAllowed: '111',
  ClaimsPaidBreakdown: '112',
  ClaimsPaymentIntegrity: '116',
  OverpaymentsTopReason: '1005',
  TotalNumberofClaimsSubmitted: '114',
  AverageClaimProcessingDays: '115',
  PaymentIntegrityCodeReviewResults: '116',
  PaymentIntegrityRecordsReceivedvsAwaiting: '117',
  PaymentIntegrityRecordsRequestedbyUHC: '118',
  EstimatedNotPaidByDollar: '120',
  EstimatedNotPaidByVolume: '121',
  MedicareStarRating: '200',
  // PriorAuthorizationRequested: '201',
  PriorAuthorizationRequested: '211',
  PriorAuthTurnaroundTime: '201',
  TopReasonsforPriorAuthorizationsNotApproved: '202',
  // PriorAuthorizationApprovalRate: '203',
  PriorAuthorizationApprovalRate: '212',
  CaseSubmissionsOverTime: '203',
  MedicareRetirementAnnualCareVisitsCompletionRateAll: '204',
  MedicareRetirementAnnualCareVisitsCompletionRateDiabetic: '204',
  QualityStarRatings: '206',
  PriorAuthorizationSavingsOpportunity: '209',
  PriorAuthorizationSubmissionDetails: '210',
  CaseSubmissionChannels: '213',
  TotalCalls: '300',
  PaperlessDelivery: '301',
  LinkEDItoCallRatio: '302',
  CallsbyCallType: '303',
  TalkTimebyCallType: '304',
  SelfServiceAdoptionRate: '305',
  ReduceReconsiderationProcessingBy: '306',
  SaveyourStaffsTimeBy: '307',
  ReduceCallsOperatingCostsBy: '308',
  ReduceClaimProcessingTimeBy: '309',
  PreferredSpecialistReferralRate: '401',
  PreferredLabNetworkUseRate: '403',
  PreferredSpecialistReferrals: '401',
  PharmacyPreferredTierPrescribing: '402',
  PreferredLabNetworkUse: '403',
  POCaServiceActivated: '335',
  PaymentsBySubmission: '310',
  ClaimsAverageTurnaroundTimetoPayment: 'NA',
  ClaimsSubmissions: 'NA',
  ClaimsPayments: 'NA',
  ClaimsNonPayments: 'NA',
  ClaimsAppeals: 'NA',
  ClaimsRecon: 'NA',
  PriorAuthorizationApproval: 'NA',
  ClaimsNonPaymentTrend: '119',
  ClaimsAppealsSubmittedTrend: 'NA',
  SmartEditsReturned: '314',
  SmartEditsResubmitted: '315',
  SmartEditsReturnedReasons: '316',
  FullAdverseDeterminationCases: '317',
  SmartEditOverTime: '1102',
  MCRReconsiderationCases: '318',
  AppealedCases: '319',
  OtherReversals: '320',
  EDICardSummary: '340',
  EDICardMainPage: '340',
  LOCMetrics: '344,345,346,347,348,349,350',
  LabNetworkUse: '407',
  SpecialistReferrals: '406',
  TierPrescribing: '408',
  LabsUsebyServicingFacilitiesandType: '411',
  PrescribingbyMedicationType: '412',
  ImagingServicesbyCenterandImagingType: '413',
  ImagingProviderDetails: '413',
  SurgerybyTypeandSurgeryCenter: '414',
  SurgicalCenterUseDetails: '414',
  // LowerCostImagingCenterUse: '404',
  LowerCostImagingProviderUseRate: '404',
  // LowerCostNonEmergentSurgeryFacilityUse: '405',
  LowerCostSurgicalCenterUseRate: '405',
  ImagingCenterUse: '409',
  ImagingProviderUse: '409',
  // NonEmergentSurgeryCenterUse: '410',
  SurgicalCenterUse: '410',
  POCAEligibilityTransactionsAndUsers: '702,703,704',
  POCAEligibilityEmrTransactions: '705',
  POCAEligibilitySystemIntegrations: '706',
  POCAProviderSearchTransactionsAndUsers: '802,803,804',
  AlternativeMedicationDisplaysSwitchesMade: '342',
  SwitchesOverTime: '343',
  SwitchRateDetail: '505',
  VBCActiveProgramsCard: '1201',
  VBCPayoutDataMetric: '1202',
  AlternativeMedicationsSwitchesMadeByLineOfBusinessTaxIDProviderAndSpecialty:
    '506',
  PACodelookupTransactionsandUsers: '601,602,603',
  POCAEligibilityTransactionsOverTime: '702',
  POCAEligibilityUsersOverTime: '703',
  POCAProviderSearchTransactionsOverTime: '802',
  POCAProviderSearchUsersOverTime: '803',
  PACodelookupTransactionsOverTime: '601',
  PACodelookupUsersOverTime: '602',
  QCEncounterOverTime: '500',
  QCUsersOverTime: '507',
  ProviderSearchesByTaxIDandProvider: '807',
  LowerCostMedicationOpportunities: '1003',
  UHCPreferredUtilizationOpportunities: '1001',
  PriorAuthorizationSubmissions: '1000',
  PointofCareAssistMetrics: '1002',
  PriorAuthorizationBanner: '1004',
  PriorAuthQuickCodeLookupInsight: '607',
  CSTransactionsOverTime: '951',
  CSUsersOverTime: '952',
  AppealsTrend: '129',
  AppealsDetails: '1006',
  claimsPaidActive: '1007',
  claimsPaidInActive: '1008',
  marketShareDetails: '1301',
  VBCInflators: '1203',
  TopReasonsforClaimsNonPaymentGS: '1900',
  ClaimAppealsOverturnRateGS: '1901',
  ClaimsPaidGS: '1902',
  ActualAllowedGS: '1903',
  ClaimsSummaryGS: '1904',
  MedicalRecordsReceivedAwaitingSubmissionGS: '1905',
  TopClaimsAppealsOverturnReasonsGS: '1906',
  TotalNumberofClaimsSubmittedGS: '1907',
  ExpectedAllowedGS: '1908',
  PIMedicalRecordCodingReviewGS: '1909',
  PIMedicalRecordsRequestedbyUHCGS: '1910',
  ClaimsYieldGS: '1911',
  ClaimAppealsOverturnedGS: '1912',
  ClaimsNotPaidGS: '1913',
  ClaimsAppealsSubmittedGS: '1914',
  ClaimsNonpaymentRateGS: '1915',
  ClaimsProcessedGS: '1916',
  ClaimsNonPaymentTrendGS: '1917',
  EstimatedNotPaidbyDollarGS: '1918',
  ClaimsNotPaidbyVolumeGS: '1919',
  AverageClaimProcessingDaysGS: '1920',
  NonPaymentDetailsGS: '1921',
  CompleteandPartialClaimsNonPaymentsTrendGS: '1922',
  ReconsiderationDetailsGS: '1923',
  PendingReconsiderationsbyVolumeGS: '1924',
  ReconsiderationOutcomesbyVolumeGS: '1925',
  ReconsiderationAverageTurnAroundTimesGS: '1926',
  TopReasonsforClaimsOverpaymentGS: '1927',
  OverpaymentDetailsGS: '1928',
  ClaimsPaidActiveGS: '1929',
  ClaimsPaidNotActiveGS: '1930',
  PaymentIntegrityEvaluations: '2000',
  PaymentIntegrityEvaluationDetails: '2001',
  PaymentIntegrityIdentifiedAdjustments: '2002',
  PaymentIntegrityMedicalRecords: '2003',
  PaymentIntegrityAuditReason: '2004',
  EDITransactionsOverTime : '352',
  EDITransactions : '353'
 

};
const MetricName = {
  HRLTaxidMetricName: 'Hospital Reference Lab',
};

export const MetricidService = {
  MetricIDs,
  MetricName,
};
